var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    viewBox: "0 0 39 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    x: 0.75,
    y: 1.25,
    width: 37.5,
    height: 37.5,
    rx: 18.75,
    stroke: "#0A142F",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 26.5H13V17.5H16V26.5Z",
    fill: "#0A142F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4911 15.5H14.474C13.5788 15.5 13 14.833 13 13.9995C13 13.1483 13.5964 12.5 14.5087 12.5C15.4209 12.5 15.9827 13.1483 16 13.9995C16 14.833 15.4209 15.5 14.4911 15.5Z",
    fill: "#0A142F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9999 26.4998H24.0519V21.7954C24.0519 20.6137 23.6253 19.8074 22.5581 19.8074C21.7437 19.8074 21.2586 20.351 21.0455 20.876C20.9675 21.0641 20.9484 21.3263 20.9484 21.5891V26.5H18C18 26.5 18.0389 18.5318 18 17.7067H20.9484V18.9522C21.3397 18.3535 22.0405 17.5 23.6057 17.5C25.5456 17.5 27 18.7571 27 21.458L26.9999 26.4998Z",
    fill: "#0A142F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/Linkedin Icon.7427833d26cbeb857f0b6f5ba2103958.svg";
export { ForwardRef as ReactComponent };